"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalHyperPasteCsvMapping = exports.ExternalHyperPasteConcurMapping = exports.ExternalCustomListMapping = exports.ExternalSupplierMapping = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var supplier_1 = require("./supplier");
var customList_1 = require("./customList");
var concur_1 = require("./hyperPaste/concur");
var csv_1 = require("./hyperPaste/csv");
var enum_1 = require("remota-common/enum");
var ExternalSupplierMapping = function (props) {
    var useSearchExternalMappings = props.useSearchExternalMappings, useUpdateExternalMappings = props.useUpdateExternalMappings;
    var _a = __read(useSearchExternalMappings({
        system: "concur",
        masterType: "supplier",
    }), 1), mappings = _a[0];
    return (react_1.default.createElement(structure_1.DetailStructure, null,
        react_1.default.createElement(panel_1.Panel, { title: "\u5916\u90E8\u30DE\u30B9\u30BF\u30DE\u30C3\u30D4\u30F3\u30B0" }, !mappings
            ? null
            : mappings.map(function (mapping) { return (react_1.default.createElement(supplier_1.MappingMain, { key: mapping.id, mapping: mapping, useUpdateExternalMappings: useUpdateExternalMappings })); }))));
};
exports.ExternalSupplierMapping = ExternalSupplierMapping;
var ExternalCustomListMapping = function (props) {
    var useSearchExternalMappings = props.useSearchExternalMappings, useUpdateExternalMappings = props.useUpdateExternalMappings, useEnabledVoucherFields = props.useEnabledVoucherFields, useSearchList = props.useSearchList;
    var _a = __read(useSearchExternalMappings({
        system: "concur",
        masterType: "customList",
    }), 1), mappings = _a[0];
    var _b = __read(useEnabledVoucherFields({ voucherType: enum_1.VoucherType.INVOICE }), 1), fields = _b[0];
    var _c = __read(useSearchList({ system: "concur" }), 1), lists = _c[0];
    return (react_1.default.createElement(structure_1.DetailStructure, null,
        react_1.default.createElement(panel_1.Panel, { title: "\u5916\u90E8\u30DE\u30B9\u30BF\u30DE\u30C3\u30D4\u30F3\u30B0" }, !mappings || !fields || !lists
            ? null
            : mappings.map(function (mapping) { return (react_1.default.createElement(customList_1.MappingMain, { key: mapping.id, mapping: mapping, useUpdateExternalMappings: useUpdateExternalMappings, fields: fields.filter(function (field) { return field.fieldType === "master" && field.isCustomField; }), lists: lists })); }))));
};
exports.ExternalCustomListMapping = ExternalCustomListMapping;
var ExternalHyperPasteConcurMapping = function (props) {
    var useSearchExternalMappings = props.useSearchExternalMappings, useUpdateExternalMappings = props.useUpdateExternalMappings, useEnabledVoucherFields = props.useEnabledVoucherFields;
    var _a = __read(useSearchExternalMappings({
        system: "concur",
        masterType: "hyperPaste",
    }), 1), mappings = _a[0];
    var _b = __read(useEnabledVoucherFields({ voucherType: enum_1.VoucherType.INVOICE }), 1), fields = _b[0];
    return (react_1.default.createElement(structure_1.DetailStructure, null,
        react_1.default.createElement(panel_1.Panel, { title: "\u5916\u90E8\u30DE\u30B9\u30BF\u30DE\u30C3\u30D4\u30F3\u30B0" }, !mappings || !fields
            ? null
            : mappings.map(function (mapping) { return (react_1.default.createElement(concur_1.MappingMain, { key: mapping.id, mapping: mapping, useUpdateExternalMappings: useUpdateExternalMappings, fields: 
                // Doesn't support nested array items field
                fields.filter(function (field) { return !/\[\*\].+\[\*\].*/.test(field.key); }) })); }))));
};
exports.ExternalHyperPasteConcurMapping = ExternalHyperPasteConcurMapping;
var ExternalHyperPasteCsvMapping = function (props) {
    var useSearchExternalMappings = props.useSearchExternalMappings, useUpdateExternalMappings = props.useUpdateExternalMappings, useEnabledVoucherFields = props.useEnabledVoucherFields, useExternalMappingCsvUpload = props.useExternalMappingCsvUpload, useExternalMappingJobRun = props.useExternalMappingJobRun;
    var _a = __read(useSearchExternalMappings({
        system: "csv",
        masterType: "hyperPaste",
    }), 1), mappings = _a[0];
    var _b = __read(useEnabledVoucherFields({ voucherType: enum_1.VoucherType.INVOICE }), 1), fields = _b[0];
    return (react_1.default.createElement(structure_1.DetailStructure, null,
        react_1.default.createElement(panel_1.Panel, { title: "\u5916\u90E8\u30DE\u30B9\u30BF\u30DE\u30C3\u30D4\u30F3\u30B0" }, !mappings || !fields
            ? null
            : mappings.map(function (mapping) { return (react_1.default.createElement(csv_1.MappingMain, { key: mapping.id, mapping: mapping, useUpdateExternalMappings: useUpdateExternalMappings, fields: 
                // Doesn't support nested array items field
                fields.filter(function (field) {
                    return !/\[\*\].+\[\*\].*/.test(field.key) &&
                        field.fieldType !== enum_1.FieldType.BOOL &&
                        field.fieldType !== enum_1.FieldType.ENUM;
                }), useExternalMappingCsvUpload: useExternalMappingCsvUpload, useExternalMappingJobRun: useExternalMappingJobRun })); }))));
};
exports.ExternalHyperPasteCsvMapping = ExternalHyperPasteCsvMapping;
